import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";
import { employeeNav } from "../../../utils/data";

const EmployeeNav = () => {


    return (
        <StyledEmployeeNav>
            <nav
                className="navbar fixed-bottom">
                <div className="container link-container">
                    {employeeNav.map(({ title, to, icon }, i) => {
                        return (
                            <li className="list-unstyled text-center" key={i}>
                                <NavLink tag={Link} activeClassName="active" to={`/user/employees${ to }`}>
                                    <h4 className="">
                                        {icon}
                                    </h4>
                                    <div className="small-text"> {title}</div>
                                </NavLink>
                            </li>
                        );
                    })}
                </div>
            </nav>
        </StyledEmployeeNav>
    );
};

export default EmployeeNav;


const StyledEmployeeNav = styled.div`
  
  nav {
      padding-left: 250px !important;
      z-index: 1000 !important;
      background-color: var(--sec-bold-color);
      
      .link-container{
            justify-content: center;
            gap:2.5rem;
          
          .list-unstyled a {
              display: flex;
              align-items: center;
              padding: 0 .8rem;
              gap:5px;
              color: var(--pry-color);
              border-bottom: transparent 4px solid;
              
              :hover {
                  transition: 0.1s ease !important;
                  border-bottom: var(--pry-bold-color) 4px solid !important;
                  border-bottom-left-radius: 3px;
                  border-bottom-right-radius: 3px;
                  color: var(--pry-bold-color) !important;
                }
                
                &.active {
                    transition: 0.1s ease !important;
                    border-bottom: var(--pry-bold-color) 4px solid !important;
                    font-weight: 600;
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                    color: var(--pry-bold-color) !important;
                }
                
                .small-text {
                    font-size: 12px !important;
                }
            }
            
        }
        
        @media screen and (max-width: 580px) {
            padding-left: 0 !important;
        }

        @media screen and (max-width: 780px) {
            
            .link-container{
                gap:0rem;
                justify-content: space-around;
                
                .list-unstyled a {
                    display:block !important;
                    padding: 0 .5rem;
                    
                    h4{
                        margin-bottom:0;
                    }
                }
                
            }
            
        }
    }
    
    `;
